import './FilterHeader.scss'

export function FilterHeader(props: { children: React.ReactNode }) {
  return (
    <div className="filter-header d-flex justify-content-between align-items-center">
      { props.children }
    </div>
  );
}
